// src/utils/normalizeAvailability.js
export function normalizeAvailability(raw) {
  if (!raw) return null;

  const data = raw.data ?? raw;

  return {
    ...data,
    availableApartments:
      (data.availableApartments ||
        data.available_apartments ||
        data.available ||
        []).map(String), // ✅ force string IDs

    prices: data.prices || {},
    suggestedDates: data.suggestedDates || {},
  };
}
